import { type CountryCode } from '@handyhand/i18n';
import type { AppEnv } from '../../environments/app-env';

export function buildConfig(env: AppEnv, country: CountryCode) {
  return {
    Basic: {
      language: country,
      platformUrl: env.platformUrl,
      defaultLanguage: country,
      supportEmail: env.supportEmail,
      supportPhone: env.supportPhone,
    },
    SEO: {
      tags: [
        { property: 'og:site_name', content: env.appName },
        { property: 'og:type', content: 'website' },
        { property: 'twitter:site', content: '@handyhand' },
        { property: 'twitter:card', content: 'summary_large_image' },
        { property: 'twitter:creator', content: '@handyhand' },
        { property: 'author', name: 'author', content: 'Saxo Agdestein' },
      ],
      defaultImage: `${env.cloudFrontImgUrl}/private/lp/sharing_cover_${country}.png`,
      logoUrl: `${env.cloudFrontImgUrl}/private/compressed/lp/webp/hh_logo_blue.webp`,
      hrefLangs: [{ language: 'en' }, { language: country }],
    },
  };
}

export type AppConfig = ReturnType<typeof buildConfig>;
